import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const Progress25Icon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 15.0001 15.0001"
        fill="none"
      >
        <g id="progress-25">
          <path
            id="Inner ellipse"
            d="M7.5 0.625105C11.297 0.625105 14.375 3.70315 14.375 7.5001C14.375 11.2971 11.297 14.3751 7.5 14.3751C3.70305 14.3751 0.625 11.2971 0.625 7.5001C0.625 3.70315 3.70305 0.625105 7.5 0.625105Z"
            stroke="#676979"
            strokeWidth="1.25002"
          />
          <g id="Union">
            <mask id="progress-25-mask" fill="white">
              <path d="M7.49989 2.18756C8.19755 2.18756 8.88854 2.32487 9.53309 2.59185C10.1776 2.85882 10.7634 3.24995 11.2567 3.74322C11.75 4.23648 12.1411 4.82238 12.4081 5.46685C12.6751 6.11138 12.8124 6.80243 12.8124 7.50006H7.49989V2.18756Z" />
            </mask>
            <path
              d="M7.49989 2.18756C8.19755 2.18756 8.88854 2.32487 9.53309 2.59185C10.1776 2.85882 10.7634 3.24995 11.2567 3.74322C11.75 4.23648 12.1411 4.82238 12.4081 5.46685C12.6751 6.11138 12.8124 6.80243 12.8124 7.50006H7.49989V2.18756Z"
              fill="#676979"
            />
            <path
              d="M7.49989 2.18756L7.49989 1.54362H6.85595V2.18756H7.49989ZM9.53309 2.59185L9.77953 1.99693L9.77952 1.99693L9.53309 2.59185ZM11.2567 3.74322L11.7121 3.28789L11.7121 3.28788L11.2567 3.74322ZM12.4081 5.46685L13.003 5.22043L13.003 5.2204L12.4081 5.46685ZM12.8124 7.50006V8.144H13.4563L13.4563 7.50005L12.8124 7.50006ZM7.49989 7.50006H6.85595V8.144H7.49989V7.50006ZM7.49989 2.18756L7.49989 2.8315C8.11307 2.8315 8.72032 2.95218 9.28667 3.18678L9.53309 2.59185L9.77952 1.99693C9.05676 1.69756 8.28203 1.54362 7.49989 1.54362L7.49989 2.18756ZM9.53309 2.59185L9.28666 3.18677C9.85319 3.42145 10.368 3.7652 10.8014 4.19856L11.2567 3.74322L11.7121 3.28788C11.1589 2.73469 10.502 2.2962 9.77953 1.99693L9.53309 2.59185ZM11.2567 3.74322L10.8014 4.19855C11.2347 4.63189 11.5785 5.14677 11.8132 5.7133L12.4081 5.46685L13.003 5.2204C12.7037 4.498 12.2653 3.84108 11.7121 3.28789L11.2567 3.74322ZM12.4081 5.46685L11.8132 5.71328C12.0477 6.2796 12.1684 6.8869 12.1684 7.50007L12.8124 7.50006L13.4563 7.50005C13.4563 6.71795 13.3024 5.94316 13.003 5.22043L12.4081 5.46685ZM12.8124 7.50006V6.85612H7.49989V7.50006V8.144H12.8124V7.50006ZM7.49989 7.50006H8.14383V2.18756H7.49989H6.85595V7.50006H7.49989Z"
              fill="#676979"
              mask="url(#progress-25-mask)"
            />
          </g>
        </g>
      </svg>
    </Center>
  );
};
